import TopBar from './top-bar';
import Sidebar from './sidebar';

import type { DashboardLayoutProps } from '@component/layout/types';

export default function DashboardLayout({ onLogout, children }: DashboardLayoutProps) {
  return (
    <div id="dash" className="show">
      <TopBar onLogout={onLogout} />
      <div className="dash-body">
        <Sidebar onLogout={onLogout} />
        <div className="content" id="main-content">
          {children}
        </div>
      </div>
      <div className="dash-footer">
        <p>© 2026 Punjab Industries, Commerce &amp; Investment Department</p>
        <p>TVET-MIS Monitoring System · IWRPP · All data maintained by PIU · Version 2.0</p>
      </div>
    </div>
  );
}
